export const isImage = (filename: string) => {
  const imageExtensions = ["jpg", "jpeg", "png"];
  const extension = filename.split(".").pop()?.toLowerCase();
  return extension !== undefined && imageExtensions.includes(extension);
};
